import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import style from '../../css/Payment.module.css'
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
function PaymentOptions({ OnSelectedOption, totalAmount }) {
    const [selectedOption, setSelectedOption] = useState('bank');
    const [isChecked, setIsChecked] = useState(false);
    const [balance, setbalance] = useState(null);
    useLanguage();

    const { t } = useTranslation();
    const handleOptionChange = (event) => {
        const value = event.target.value || 'bank';

        setSelectedOption(value);
        OnSelectedOption(value)

    };
    useEffect(() => {
        setSelectedOption('bank');
        OnSelectedOption('bank');

    }, []);

    // console.log("totalAmount", totalAmount)
    // console.log("")

    // console.log("selectedOption", selectedOption)
    const handleMethodChange = (event) => {
        setIsChecked(event.target.checked);

    }
    useEffect(() => {
        const storedBalance = parseFloat(localStorage.getItem('Balance')) || 0; // Retrieve and ensure it's a number
        setbalance(storedBalance);
    }, [balance])
    return (
        <div style={{ margin: 0, padding: 0 }} className="container">
            <div className="row d-flex align-items-stretch g-2">
                <div className="col-md-6">
                    <div className={`border rounded p-2 h-100 ${selectedOption === 'napas' ? 'border-primary' : ''}`}
                        style={{

                            fontSize: '1rem', // Chỉnh size chữ tại đây
                            wordWrap: 'break-word', // Đảm bảo chữ không bị tràn
                            whiteSpace: 'normal', // Không giữ chữ trên 1 dòng
                        }}
                    >
                        <label className={`d-flex align-items-center ${style.container}`}>
                            <input
                                type="radio"
                                value="napas"
                                checked={selectedOption === 'napas'}
                                onChange={handleOptionChange}
                                className="me-2"
                            // disabled="true"
                            />
                            <svg
                                style={{ width: "30px", height: "40px" }}
                                xmlns="http://www.w3.org/2000/svg"
                                shapeRendering="geometricPrecision"
                                textRendering="geometricPrecision"
                                imageRendering="optimizeQuality"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                viewBox="0 0 512 489.435"
                            >
                                <path
                                    fill="#EF4147"
                                    d="M266.131 425.009c-3.121 2.276-7.359 2.59-10.837.357-37.51-23.86-69.044-52.541-93.797-83.672-34.164-42.861-55.708-90.406-63.066-136.169-7.493-46.427-.492-91.073 22.612-127.381 9.098-14.36 20.739-27.428 34.923-38.714C188.57 13.428 225.81-.263 262.875.004c35.726.268 70.96 13.601 101.422 41.39 10.707 9.723 19.715 20.872 27.075 32.96 24.843 40.898 30.195 93.083 19.269 145.981-17.047 82.829-71.772 160.521-144.51 204.674zM255.789 37.251c69.041 0 125.006 55.965 125.006 125.005 0 69.041-55.965 125.006-125.006 125.006-69.04 0-125.005-55.965-125.005-125.006 0-69.04 55.965-125.005 125.005-125.005z"
                                />
                                <path
                                    fill="#1A1A1A"
                                    d="M180.244 135.089l75.352-53.441 75.739 53.441H180.244zm-70.72 182.095c6.788 0 12.29 5.502 12.29 12.29 0 6.788-5.502 12.291-12.29 12.291H71.37L33.265 464.853h444.623l-41.373-123.088H407.93c-6.788 0-12.291-5.503-12.291-12.291s5.503-12.29 12.291-12.29h46.171L512 489.435H0l53.325-172.251h56.199zm75.305-94.728v-17.523h5.185l4.943-3.88v-46.549h-10.1v-11.15h141.481v11.15h-10.097v46.549l4.943 3.88h5.284v17.523H184.829zm33.693-17.523h5.714l4.942-3.88v-46.549h-15.596v46.549l4.94 3.88zm34.222 0h5.712l4.939-3.88v-46.549h-15.592v46.549l4.941 3.88zm34.215 0h5.713l4.941-3.88v-46.549h-15.596v46.549l4.942 3.88z"
                                />
                            </svg>
                            <span
                                style={{
                                    fontSize: '15px', // Đảm bảo chữ lớn hơn
                                    marginLeft: '5px', // Khoảng cách giữa icon và chữ
                                    whiteSpace: 'normal', // Đảm bảo chữ không bị tràn
                                }}
                            >
                                {t("Domestic ATM card")}
                            </span>
                        </label>
                    </div>
                </div>

                {balance >= totalAmount ? (
                    <div className="col-md-6">
                        <div
                            className={`border rounded p-2 h-100 ${selectedOption === 'wallet' ? 'border-primary' : ''
                                }`}
                            style={{
                                fontSize: '1rem',
                                wordWrap: 'break-word',
                                whiteSpace: 'normal',
                            }}
                        >
                            <label className={`d-flex align-items-center ${style.container}`}>
                                <input
                                    type="radio"
                                    value="wallet"
                                    checked={selectedOption === 'wallet'}
                                    onChange={handleOptionChange}
                                    className="me-2"
                                // disabled="true"
                                />
                                <svg
                                    className="svg-icon"
                                    style={{
                                        width: '3em',
                                        height: '2em',
                                        verticalAlign: 'middle',
                                        fill: 'currentColor',
                                        overflow: 'hidden',
                                    }}
                                    viewBox="0 0 1024 1024"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M828.6 421L379.7 689.3c-8.4 5-19.3 2.3-24.3-6.1l-173-289.5c-5-8.4-2.3-19.3 6.1-24.3l448.9-268.3c8.4-5 19.3-2.3 24.3 6.1l173 289.5c5.1 8.4 2.3 19.3-6.1 24.3z"
                                        fill="#FFC107"
                                    />
                                    <path
                                        d="M211.808 442.813l479.416-286.51 71.05 118.888L282.86 561.7z"
                                        fill="#FF8F00"
                                    />
                                    <path
                                        d="M862.7 925.4H135c-19.6 0-35.5-15.9-35.5-35.5V366.4c0-19.6 15.9-35.5 35.5-35.5h727.6c19.6 0 35.5 15.9 35.5 35.5V890c0.1 19.6-15.8 35.4-35.4 35.4z"
                                        fill="#F44336"
                                    />
                                </svg>
                                <span
                                    style={{
                                        fontSize: '15px',
                                    }}
                                >
                                    {t("Wallet Balance")}
                                    <br />
                                    {balance &&
                                        new Intl.NumberFormat('vi-VN', {
                                            style: 'currency',
                                            currency: 'VND',
                                        }).format(balance)}
                                </span>
                            </label>
                        </div>
                    </div>
                ) : (
                    <div className="col-md-6">
                        <div
                            className="border rounded p-2 h-100"
                            style={{
                                fontSize: '1rem',
                                wordWrap: 'break-word',
                                whiteSpace: 'normal',
                                opacity: '0.6', // Visual indication it's disabled
                                pointerEvents: 'none', // Prevent clicks
                            }}
                        >
                            <label className={`d-flex align-items-center ${style.container}`}>
                                <input
                                    type="radio"
                                    value="wallet"
                                    disabled // Disable the input field
                                    className="me-2"
                                />
                                <svg
                                    className="svg-icon"
                                    style={{
                                        width: '3em',
                                        height: '2em',
                                        verticalAlign: 'middle',
                                        fill: 'currentColor',
                                        overflow: 'hidden',
                                    }}
                                    viewBox="0 0 1024 1024"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M828.6 421L379.7 689.3c-8.4 5-19.3 2.3-24.3-6.1l-173-289.5c-5-8.4-2.3-19.3 6.1-24.3l448.9-268.3c8.4-5 19.3-2.3 24.3 6.1l173 289.5c5.1 8.4 2.3 19.3-6.1 24.3z"
                                        fill="#FFC107"
                                    />
                                    <path
                                        d="M211.808 442.813l479.416-286.51 71.05 118.888L282.86 561.7z"
                                        fill="#FF8F00"
                                    />
                                    <path
                                        d="M862.7 925.4H135c-19.6 0-35.5-15.9-35.5-35.5V366.4c0-19.6 15.9-35.5 35.5-35.5h727.6c19.6 0 35.5 15.9 35.5 35.5V890c0.1 19.6-15.8 35.4-35.4 35.4z"
                                        fill="#F44336"
                                    />
                                </svg>
                                <span
                                    style={{
                                        fontSize: '15px',
                                        marginLeft: '5px',
                                    }}
                                >
                                    <br />
                                    {balance &&
                                        new Intl.NumberFormat('vi-VN', {
                                            style: 'currency',
                                            currency: 'VND',
                                        }).format(balance)}
                                </span>
                            </label>
                        </div>
                    </div>
                )}
                <div className="col-md-6">
                    <div className={`border rounded p-2 h-100 ${selectedOption === 'paypal' ? 'border-primary' : ''}`}
                        style={{

                            fontSize: '1rem', // Chỉnh size chữ tại đây
                            wordWrap: 'break-word', // Đảm bảo chữ không bị tràn
                            whiteSpace: 'normal', // Không giữ chữ trên 1 dòng
                        }}>
                        <label className={`d-flex align-items-center ${style.container}`}>
                            <input
                                type="radio"
                                value="paypal"
                                checked={selectedOption === 'paypal'}
                                onChange={handleOptionChange}
                                className="me-2"
                            // disabled="true"

                            />
                            <svg
                                style={{ width: "40px", height: "40px" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width={1280}
                                height="339.345"
                                viewBox="0 0 338.667 89.785"
                            // xmlns:v="https://vecta.io/nano"
                            >
                                <g transform="translate(936.898 -21.779)">
                                    <path
                                        clipPath="none"
                                        d="M-828.604 39.734c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025c.108-.688.701-1.195 1.398-1.195h8.699c10.164 0 18.792-7.416 20.368-17.465 1.589-10.134-6.328-18.971-17.549-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.488 6.507-9.031 6.507h-7.084zm45.788 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.647 13.717 5.852 21.253 0 0 9.737 7.255 20.698-.447l-.189 1.203a1.31 1.31 0 0 0 1.292 1.513h9.083c.697 0 1.289-.507 1.398-1.195l5.525-35.038a1.31 1.31 0 0 0-1.292-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
                                        fill="#003087"
                                    />
                                    <path
                                        clipPath="none"
                                        d="M-697.804 39.734c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025c.108-.688.701-1.195 1.398-1.195h8.699c10.164 0 18.791-7.416 20.366-17.465 1.59-10.134-6.326-18.971-17.547-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.487 6.507-9.031 6.507h-7.084zm45.787 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.645 13.717 5.854 21.253 0 0 9.735 7.255 20.697-.447l-.189 1.203a1.31 1.31 0 0 0 1.294 1.513h9.082c.697 0 1.289-.507 1.398-1.195l5.527-35.038a1.31 1.31 0 0 0-1.294-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
                                        fill="#0070e0"
                                    />
                                    <path
                                        clipPath="none"
                                        d="M-745.92 55.859c-.72 0-1.232.703-1.012 1.388l9.958 30.901-9.004 14.562c-.437.707.071 1.62.902 1.62h10.642a1.77 1.77 0 0 0 1.513-.854l27.811-46.007c.427-.707-.083-1.611-.909-1.611h-10.641a1.77 1.77 0 0 0-1.522.869l-10.947 18.482-5.557-18.345c-.181-.597-.732-1.006-1.355-1.006z"
                                        fill="#003087"
                                    />
                                    <path
                                        clipPath="none"
                                        d="M-609.107 39.734c-.696 0-1.289.507-1.398 1.195l-8.07 51.163a1.31 1.31 0 0 0 1.294 1.515h9.568c.696 0 1.289-.507 1.398-1.195l8.068-51.165a1.31 1.31 0 0 0-1.292-1.513z"
                                        fill="#0070e0"
                                    />
                                    <path
                                        clipPath="none"
                                        d="M-908.37 39.734a2.59 2.59 0 0 0-2.556 2.185l-4.247 26.936c.198-1.258 1.282-2.185 2.556-2.185h12.445c12.525 0 23.153-9.137 25.095-21.519a20.76 20.76 0 0 0 .245-2.793c-3.183-1.669-6.922-2.624-11.019-2.624z"
                                        fill="#001c64"
                                    />
                                    <path
                                        clipPath="none"
                                        d="M-874.832 42.359a20.76 20.76 0 0 1-.245 2.793c-1.942 12.382-12.571 21.519-25.095 21.519h-12.445c-1.273 0-2.358.926-2.556 2.185l-3.905 24.752-2.446 15.528a2.1 2.1 0 0 0 2.075 2.43h13.508a2.59 2.59 0 0 0 2.556-2.185l3.558-22.567a2.59 2.59 0 0 1 2.558-2.185h7.953c12.525 0 23.153-9.137 25.095-21.519 1.379-8.788-3.047-16.784-10.611-20.75z"
                                        fill="#0070e0"
                                    />
                                    <path
                                        clipPath="none"
                                        d="M-923.716 21.779c-1.273 0-2.358.926-2.556 2.183l-10.6 67.216c-.201 1.276.785 2.43 2.077 2.43h15.719l3.903-24.752 4.247-26.936a2.59 2.59 0 0 1 2.556-2.185h22.519c4.098 0 7.836.956 11.019 2.624.218-11.273-9.084-20.58-21.873-20.58z"
                                        fill="#003087"
                                    />
                                </g>
                            </svg> &nbsp; &nbsp;
                            <span
                                style={{
                                    fontSize: '15px', // Đảm bảo chữ lớn hơn
                                    marginLeft: '5px', // Khoảng cách giữa icon và chữ
                                    whiteSpace: 'normal', // Đảm bảo chữ không bị tràn
                                }}
                            >Paypal
                            </span>                        </label>
                    </div>
                </div>
                <div className="col-md-6 ">
                    <div className={`border rounded p-2 h-100 ${selectedOption === 'qr' ? 'border-primary' : ''}`}
                        style={{
                            fontSize: '1rem', // Chỉnh size chữ tại đây
                            wordWrap: 'break-word', // Đảm bảo chữ không bị tràn
                            whiteSpace: 'normal', // Không giữ chữ trên 1 dòng
                        }}
                    >
                        <label className={`d-flex align-items-center ${style.container}`}>
                            <input
                                type="radio"
                                value="qr"
                                checked={selectedOption === 'qr'}
                                onChange={handleOptionChange}
                                className="me-2"
                            />
                            <svg
                                style={{ width: "30px", height: "30px" }}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M3 3h4v4H3V3m6 0h4v4h-4V3m6 0h4v4h-4V3M3 9h4v4H3V9m6 0h4v4h-4V9m6 0h4v4h-4V9M3 15h4v4H3v-4m6 0h4v4h-4v-4m6 0h4v4h-4v-4m-9 6h2v2H6v-2m4 0h4v2h-4v-2m6 0h2v2h-2v-2z" />
                            </svg>
                            <span
                                style={{
                                    fontSize: '15px', // Đảm bảo chữ lớn hơn
                                    marginLeft: '5px', // Khoảng cách giữa icon và chữ
                                    whiteSpace: 'normal', // Đảm bảo chữ không bị tràn
                                }}
                            >
                                QR
                            </span>
                        </label>
                    </div>

                </div>

                <div className="col-md-6 ">
                    <div className={`border rounded p-2 h-100 ${selectedOption === 'bank' ? 'border-primary' : ''}`}
                        style={{
                            fontSize: '1rem', // Chỉnh size chữ tại đây
                            wordWrap: 'break-word', // Đảm bảo chữ không bị tràn
                            whiteSpace: 'normal', // Không giữ chữ trên 1 dòng
                        }}
                    >
                        <label className={`d-flex align-items-center ${style.container}`}>
                            <input
                                type="radio"
                                value="bank"
                                checked={selectedOption === 'bank'}
                                onChange={handleOptionChange}
                                className="me-2"
                            />
                            <svg
                                style={{ width: "30px", height: "30px" }}
                                id="Layer_1"
                                data-name="Layer 1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 122.88 67.85"
                            >
                                <defs>
                                    <style>{".cls-1{fill-rule:evenodd;}"}</style>
                                </defs>
                                <title>money-transfer</title>
                                <path
                                    className="cls-1"
                                    d="M58.41,61.48A29,29,0,0,1,31.93,35.83c-1.52.5-3.06,1.09-4.62,1.75l2.52,12.47L0,30H0L19.72,0l2.57,12.71a44.08,44.08,0,0,1,16.89.46,28.93,28.93,0,0,1,18-9.41,26.48,26.48,0,0,1,3.58-.22A33.12,33.12,0,0,1,68,4.45a29,29,0,0,1,21.8,27.94,56.84,56.84,0,0,0,5.79-2.13L93.05,17.8l29.83,20h0l-19.72,30-2.57-12.72A42.92,42.92,0,0,1,80.53,53.8a29,29,0,0,1-12.46,6.85,30.72,30.72,0,0,1-9.66.83ZM63.57,39.1a3.84,3.84,0,0,0-.3-1.6,2.74,2.74,0,0,0-.94-1.08,9.28,9.28,0,0,0-1.72-.9,48.55,48.55,0,0,1-4.49-2.19,8.75,8.75,0,0,1-3-2.74A7.48,7.48,0,0,1,52,26.3a7.27,7.27,0,0,1,1.19-4.14,7.81,7.81,0,0,1,3.27-2.74,10.72,10.72,0,0,1,3.54-.9v-3.1h3.17V18.6a9.57,9.57,0,0,1,3,.94,8,8,0,0,1,3.29,3.09,9.37,9.37,0,0,1,1.19,4.83H63.74A4,4,0,0,0,63,24.61a2.48,2.48,0,0,0-1.84-.78,2.32,2.32,0,0,0-1.33.35,2,2,0,0,0-.75.94,3.22,3.22,0,0,0-.24,1.26,2.83,2.83,0,0,0,.28,1.3,2.94,2.94,0,0,0,.92,1,10.74,10.74,0,0,0,1.8,1A41,41,0,0,1,66.21,32a9.3,9.3,0,0,1,3.08,2.8,7.46,7.46,0,0,1,1.13,4.28A7.13,7.13,0,0,1,66,46a11.06,11.06,0,0,1-3.27.84v3H59.54v-3a14.52,14.52,0,0,1-2-.39,9.92,9.92,0,0,1-3.29-1.58,7.72,7.72,0,0,1-2.37-2.92,10,10,0,0,1-.9-4.48h6.84a5.79,5.79,0,0,0,.28,1.95,3.24,3.24,0,0,0,.74,1.25,2.69,2.69,0,0,0,1.07.67,3.66,3.66,0,0,0,1.28.21,2.64,2.64,0,0,0,1.4-.33,2,2,0,0,0,.78-.89,3,3,0,0,0,.25-1.21ZM63.2,56.69h0l-.58.05c-.63,0-1.26.07-1.9.07A24.21,24.21,0,0,1,49.73,11h0l.5-.25a24.21,24.21,0,1,1,13,45.9Z"
                                />
                            </svg>
                            <span
                                style={{
                                    fontSize: '15px', // Đảm bảo chữ lớn hơn
                                    marginLeft: '5px', // Khoảng cách giữa icon và chữ
                                    whiteSpace: 'normal', // Đảm bảo chữ không bị tràn
                                }}
                            >
                                {t("Bank transfer")}
                            </span>
                        </label>
                    </div>

                </div>


                <div className="col-md-6 ">
                    <div className={`border rounded p-2 h-100 ${selectedOption === 'momo' ? 'border-primary' : ''}`}
                        style={{

                            fontSize: '1rem', // Chỉnh size chữ tại đây
                            wordWrap: 'break-word', // Đảm bảo chữ không bị tràn
                            whiteSpace: 'normal', // Không giữ chữ trên 1 dòng
                        }}>
                        <label className={`d-flex align-items-center ${style.container}`}>
                            <input
                                type="radio"
                                value="momo"
                                checked={selectedOption === 'momo'}
                                onChange={handleOptionChange}
                                className="me-2"
                                disabled="true"

                            />
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 61 61"
                                style={{ enableBackground: "new 0 0 61 61" }}
                                xmlSpace="preserve"
                                width={"30px"}
                                height={"40px"}
                            >
                                <style
                                    type="text/css"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#A50064;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;}\n\t.st3{fill:#A50064;}\n"
                                    }}
                                />
                                <circle className="st0" cx={-544} cy="30.5" r={168} />
                                <g>
                                    <path
                                        className="st1"
                                        d="M-487.2,21.5c23.5,0,42.5-19,42.5-42.5s-19-42.5-42.5-42.5s-42.5,19-42.5,42.5S-510.7,21.5-487.2,21.5z
		 M-487.2-39.1c10,0,18.1,8.1,18.1,18.1s-8.1,18.1-18.1,18.1S-505.3-11-505.3-21S-497.2-39.1-487.2-39.1z"
                                    />
                                    <path
                                        className="st1"
                                        d="M-573.8-63.5c-7.2,0-13.8,2.4-19.1,6.4c-5.3-4-12-6.4-19.1-6.4c-17.7,0-32,14.3-32,31.9v53.1h24.4v-53.4
		c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.4v-53.4c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.4v-53.1
		C-542-49.2-556.2-63.5-573.8-63.5z"
                                    />
                                    <path
                                        className="st1"
                                        d="M-487.2,39.9c-23.5,0-42.5,19-42.5,42.5s19,42.5,42.5,42.5s42.5-19,42.5-42.5S-463.7,39.9-487.2,39.9z
		 M-487.2,100.5c-10,0-18.1-8.1-18.1-18.1s8.1-18.1,18.1-18.1s18.1,8.1,18.1,18.1C-469.1,92.4-477.2,100.5-487.2,100.5z"
                                    />
                                    <path
                                        className="st1"
                                        d="M-573.8,39.9c-7.2,0-13.8,2.4-19.1,6.4c-5.3-4-12-6.4-19.1-6.4c-17.6,0-31.9,14.3-31.9,31.9V125h24.4V71.5
		c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.4V71.5c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.3V71.7
		C-542,54.2-556.2,39.9-573.8,39.9z"
                                    />
                                </g>
                                <g>
                                    <path
                                        className="st0"
                                        d="M-79.5-117.5h-256c-11,0-20,9-20,20v256c0,11,9,20,20,20h256c11,0,20-9,20-20v-256
		C-59.5-108.5-68.5-117.5-79.5-117.5z"
                                    />
                                    <g>
                                        <path
                                            className="st1"
                                            d="M-150.7,21.5c23.5,0,42.5-19,42.5-42.5s-19-42.5-42.5-42.5s-42.5,19-42.5,42.5S-174.2,21.5-150.7,21.5z
			 M-150.7-39.1c10,0,18.1,8.1,18.1,18.1s-8.1,18.1-18.1,18.1S-168.8-11-168.8-21S-160.7-39.1-150.7-39.1z"
                                        />
                                        <path
                                            className="st1"
                                            d="M-150.7,39.9c-23.5,0-42.5,19-42.5,42.5s19,42.5,42.5,42.5s42.5-19,42.5-42.5S-127.2,39.9-150.7,39.9z
			 M-150.7,100.5c-10,0-18.1-8.1-18.1-18.1s8.1-18.1,18.1-18.1s18.1,8.1,18.1,18.1C-132.6,92.4-140.7,100.5-150.7,100.5z"
                                        />
                                        <path
                                            className="st1"
                                            d="M-237.3,39.9c-7.2,0-13.8,2.4-19.1,6.4c-5.3-4-12-6.4-19.1-6.4c-17.6,0-31.9,14.3-31.9,31.9V125h24.4V71.5
			c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.4V71.5c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.3V71.7
			C-205.5,54.2-219.7,39.9-237.3,39.9z"
                                        />
                                        <path
                                            className="st1"
                                            d="M-237.3-63.5c-7.2,0-13.8,2.4-19.1,6.4c-5.3-4-12-6.4-19.1-6.4c-17.7,0-32,14.3-32,31.9v53.1h24.4v-53.4
			c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.4v-53.4c0-4,3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2v53.4h24.4v-53.1
			C-205.5-49.2-219.7-63.5-237.3-63.5z"
                                        />
                                    </g>
                                </g>
                                <g id="_x35_.-Kiểm-tra-giao-dịch">
                                    <g id="momo_icon_square_pinkbg">
                                        <path
                                            id="Path"
                                            className="st2"
                                            d="M56.4,0.5H4.6c-1.5,0-2.8,0-4.1,0v55.9c0,1.5,0,2.8,0,4.1h60c0-1.2,0-2.6,0-4.1V0.5
			C59.3,0.5,57.9,0.5,56.4,0.5z"
                                        />
                                        <g id="Group" transform="translate(4.000000, 5.500000)">
                                            <path
                                                id="Shape"
                                                className="st3"
                                                d="M41.4,22.6c6.1,0,11.1-4.9,11.1-11s-5-11-11.1-11s-11.1,4.9-11.1,11S35.3,22.6,41.4,22.6z
				 M41.4,6.8c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7S38.8,6.8,41.4,6.8z"
                                            />
                                            <path
                                                id="Shape_1_"
                                                className="st3"
                                                d="M41.4,27.4c-6.1,0-11.1,4.9-11.1,11s5,11,11.1,11s11.1-4.9,11.1-11S47.5,27.4,41.4,27.4z
				 M41.4,43.1c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7c2.6,0,4.7,2.1,4.7,4.7C46.1,41,44,43.1,41.4,43.1z"
                                            />
                                            <path
                                                id="Path_1_"
                                                className="st3"
                                                d="M18.8,27.4c-1.9,0-3.6,0.6-5,1.7c-1.4-1-3.1-1.7-5-1.7c-4.6,0-8.3,3.7-8.3,8.3v13.8h6.4V35.6
				c0-1,0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9v13.9H17V35.6c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9v13.9h6.3V35.6
				C27.1,31.1,23.4,27.4,18.8,27.4z"
                                            />
                                            <path
                                                id="Path_2_"
                                                className="st3"
                                                d="M18.8,0.5c-1.9,0-3.6,0.6-5,1.7c-1.4-1-3.1-1.7-5-1.7c-4.6,0-8.3,3.7-8.3,8.3v13.8h6.4V8.7
				c0-1,0.8-1.9,1.9-1.9s1.9,0.8,1.9,1.9v13.9H17V8.7c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9v13.9h6.4V8.8
				C27.1,4.2,23.4,0.5,18.8,0.5z"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <span
                                style={{
                                    fontSize: '15px', // Đảm bảo chữ lớn hơn
                                    marginLeft: '5px', // Khoảng cách giữa icon và chữ
                                    whiteSpace: 'normal', // Đảm bảo chữ không bị tràn
                                }}
                            >
                                Momo
                            </span>

                        </label>
                    </div>
                </div>

                <div className="col-md-12 ">
                    <div className={`border rounded p-2 h-100 ${selectedOption === 'visa' ? 'border-primary' : ''}`}
                        style={{

                            fontSize: '1rem', // Chỉnh size chữ tại đây
                            wordWrap: 'break-word', // Đảm bảo chữ không bị tràn
                            whiteSpace: 'normal', // Không giữ chữ trên 1 dòng
                        }}>
                        <label className={`d-flex align-items-center ${style.container}`}>
                            <input
                                type="radio"
                                value="visa"
                                checked={selectedOption === 'visa'}
                                onChange={handleOptionChange}
                                className="me-2"
                            // disabled="true"

                            />
                            <svg
                                style={{ width: "25px", height: "25px" }}
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.1"
                                id="Layer_1"
                                x="0px"
                                y="0px"
                                width="1000.046"
                                height="323.65302"
                                viewBox="0 0 1000.046 323.653"
                                xmlSpace="preserve"
                            >
                                <metadata id="metadata23">
                                    <g>
                                        <g>
                                            <text>image/svg+xml</text>
                                            <text>http://purl.org/dc/dcmitype/StillImage</text>
                                        </g>
                                    </g>
                                </metadata>
                                <g
                                    id="g4158"
                                    transform="matrix(4.4299631,0,0,4.4299631,-81.165783,-105.04783)"
                                >
                                    <polygon
                                        points="116.145,95.719 97.858,95.719 109.296,24.995 127.582,24.995 "
                                        id="polygon9"
                                        style={{ fill: "#00579f" }}
                                    />
                                    <path
                                        d="m 182.437,26.724 c -3.607,-1.431 -9.328,-3.011 -16.402,-3.011 -18.059,0 -30.776,9.63 -30.854,23.398 -0.15,10.158 9.105,15.8 16.027,19.187 7.075,3.461 9.48,5.72 9.48,8.805 -0.072,4.738 -5.717,6.922 -10.982,6.922 -7.301,0 -11.213,-1.126 -17.158,-3.762 l -2.408,-1.13 -2.559,15.876 c 4.289,1.954 12.191,3.688 20.395,3.764 19.188,0 31.68,-9.481 31.828,-24.153 0.073,-8.051 -4.814,-14.22 -15.35,-19.261 -6.396,-3.236 -10.313,-5.418 -10.313,-8.729 0.075,-3.01 3.313,-6.093 10.533,-6.093 5.945,-0.151 10.313,1.278 13.622,2.708 l 1.654,0.751 2.487,-15.272 0,0 z"
                                        id="path11"
                                        style={{ fill: "#00579f" }}
                                    />
                                    <path
                                        d="m 206.742,70.664 c 1.506,-4.063 7.301,-19.788 7.301,-19.788 -0.076,0.151 1.503,-4.138 2.406,-6.771 l 1.278,6.094 c 0,0 3.463,16.929 4.215,20.465 -2.858,0 -11.588,0 -15.2,0 l 0,0 z m 22.573,-45.669 -14.145,0 c -4.362,0 -7.676,1.278 -9.558,5.868 l -27.163,64.855 19.188,0 c 0,0 3.159,-8.729 3.838,-10.609 2.105,0 20.771,0 23.479,0 0.525,2.483 2.182,10.609 2.182,10.609 l 16.932,0 -14.753,-70.723 0,0 z"
                                        id="path13"
                                        style={{ fill: "#00579f" }}
                                    />
                                    <path
                                        d="M 82.584,24.995 64.675,73.222 62.718,63.441 C 59.407,52.155 49.023,39.893 37.435,33.796 l 16.404,61.848 19.338,0 28.744,-70.649 -19.337,0 0,0 z"
                                        id="path15"
                                        style={{ fill: "#00579f" }}
                                    />
                                    <path
                                        d="m 48.045,24.995 -29.422,0 -0.301,1.429 c 22.951,5.869 38.151,20.016 44.396,37.02 L 56.322,30.94 c -1.053,-4.517 -4.289,-5.796 -8.277,-5.945 l 0,0 z"
                                        id="path17"
                                        style={{ fill: "#faa61a" }}
                                    />
                                </g>
                            </svg>
                            <span
                                style={{
                                    fontSize: '15px', // Đảm bảo chữ lớn hơn
                                    marginLeft: '5px', // Khoảng cách giữa icon và chữ
                                    whiteSpace: 'normal', // Đảm bảo chữ không bị tràn
                                }}
                            >
                                {t("Credit Card")}

                            </span>
                        </label>
                    </div>
                </div>
            </div>


        </div>

    );
}

export default PaymentOptions;
